var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("i", { staticClass: "el-icon-receiving" }),
      _c("br"),
      _c("span", [_vm._v("No data")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }